import { render, staticRenderFns } from "./DataAssetGrade.vue?vue&type=template&id=efaaf53c&scoped=true"
import script from "./DataAssetGrade.vue?vue&type=script&lang=js"
export * from "./DataAssetGrade.vue?vue&type=script&lang=js"
import style0 from "./DataAssetGrade.vue?vue&type=style&index=0&id=efaaf53c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efaaf53c",
  null
  
)

export default component.exports